import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { Document, IDocument } from 'document/document';
import { IModule, Module } from 'module/module';
import { IUser, User } from 'user/user';

export interface IMessage extends IEntity {
	readonly date: Date;
	readonly content: string;
	readonly moduleId: string;
	readonly authorId: string;
	readonly documentId: string;
	readonly visioSessionId: string;
	readonly participantsId: ReadonlyArray<string>;
	readonly author$: Observable<IUser>;
	readonly module$: Observable<IModule>;
	readonly document$: Observable<IDocument>;
}

export class Message extends Entity implements IMessage {
	private _date: Date;
	private _content: string;
	private _moduleId: string;
	private _authorId: string;
	private _documentId: string;
	private _visioSessionId: string;
	private _participantsId: string[];
	private _author$: Observable<User>;
	private _module$: Observable<Module>;
	private _document$: Observable<Document>;

	constructor(
		id: string,
		date: Date,
		content: string,
		moduleId: string,
		authorId: string,
		documentId: string,
		visioSessionId: string,
		updateTimestamp: number,
		participantsId: string[],
		author$: Observable<User> = of(null),
		module$: Observable<Module> = of(null),
		document$: Observable<Document> = of(null)
	) {
		super(id, null, updateTimestamp);
		this._date = date;
		this._content = content;
		this._moduleId = moduleId;
		this._authorId = authorId;
		this._documentId = documentId;
		this._visioSessionId = visioSessionId;
		this._participantsId = participantsId;
		this._author$ = author$;
		this._module$ = module$;
		this._document$ = document$;
	}

	public get date(): Date {
		return this._date;
	}

	public get authorId(): string {
		return this._authorId;
	}

	public get content(): string {
		return this._content;
	}

	public get moduleId(): string {
		return this._moduleId;
	}

	public get documentId(): string {
		return this._documentId;
	}

	public get visioSessionId(): string {
		return this._visioSessionId;
	}

	public get participantsId(): string[] {
		return this._participantsId;
	}

	public get author$(): Observable<User> {
		return this._author$;
	}

	public get module$(): Observable<Module> {
		return this._module$;
	}

	public get document$(): Observable<Document> {
		return this._document$;
	}
}
